// Library imports
import styled from 'styled-components';

export const ModalBodyWrapper = styled.div`
    padding: 0;
    background: #f8f9fa;
`;

export const LoadingContainer = styled.div`
    text-align: center;
    padding: 3rem 1rem;
`;

export const ErrorContainer = styled.div`
    text-align: center;
    padding: 3rem 1rem;
`;

export const NoDataContainer = styled.div`
    text-align: center;
    padding: 3rem 1rem;
    color: #6c757d;
`;

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const ComparisonSection = styled.div`
    padding: 1rem;
    background: #f8f9fa;

    @media (max-width: 768px) {
        padding: 0.75rem;
    }
`;

export const DateTimeHeader = styled.div`
    text-align: center;
    font-size: 0.875rem;
    color: #495057;
    font-weight: 500;
    margin-bottom: 1rem;
`;

export const ComparisonCard = styled.div`
    background: white;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
`;

export const CardContent = styled.div`
    padding: 1.25rem;

    @media (max-width: 768px) {
        padding: 1rem;
    }
`;

export const ScoreComparisonRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-around;
    gap: 1rem;
    padding-bottom: 1.25rem;
    border-bottom: 2px solid #e9ecef;
    margin-bottom: 1.25rem;

    @media (max-width: 768px) {
        gap: 0.5rem;
        padding-bottom: 1rem;
        margin-bottom: 1rem;
    }
`;

export const TeamColumn = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
`;

export const TeamLabel = styled.div`
    font-size: 1rem;
    font-weight: 700;
    color: #495057;
    margin-bottom: 0.75rem;
    text-align: center;

    @media (max-width: 768px) {
        font-size: 0.875rem;
        margin-bottom: 0.5rem;
    }
`;

export const ScoreGroup = styled.div`
    display: flex;
    gap: 0.75rem;
    align-items: center;

    @media (max-width: 768px) {
        gap: 0.5rem;
        flex-direction: column;
    }
`;

export const ScoreItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.25rem;
`;

export const ScoreLabel = styled.div`
    font-size: 0.625rem;
    color: #6c757d;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-weight: 600;

    @media (max-width: 768px) {
        font-size: 0.5rem;
    }
`;

export const ScoreValue = styled.div`
    font-size: 1.75rem;
    font-weight: 800;
    padding: 0.5rem 0.75rem;
    border-radius: 8px;
    min-width: 60px;
    text-align: center;
    background: ${({ $type }) => ($type === 'predicted' ? 'rgba(102, 126, 234, 0.1)' : 'rgba(40, 167, 69, 0.1)')};
    color: ${({ $type }) => ($type === 'predicted' ? '#667eea' : '#28a745')};
    border: 2px solid ${({ $type }) => ($type === 'predicted' ? '#667eea' : '#28a745')};

    @media (max-width: 768px) {
        font-size: 1.25rem;
        padding: 0.375rem 0.5rem;
        min-width: 50px;
    }
`;

export const VsDivider = styled.div`
    font-size: 1.25rem;
    font-weight: 700;
    color: #adb5bd;
    padding: 0 0.5rem;

    @media (max-width: 768px) {
        font-size: 1rem;
        padding: 0 0.25rem;
    }
`;

export const WinnerRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1.5rem;

    @media (max-width: 768px) {
        gap: 0.75rem;
    }
`;

export const WinnerSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    flex: 1;

    @media (max-width: 768px) {
        gap: 0.375rem;
    }
`;

export const WinnerLabel = styled.div`
    font-size: 0.75rem;
    color: #6c757d;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-weight: 600;

    @media (max-width: 768px) {
        font-size: 0.625rem;
    }
`;

export const WinnerTeam = styled.div`
    font-size: 1.5rem;
    font-weight: 800;
    padding: 0.75rem 1.25rem;
    border-radius: 10px;
    background: ${({ $type, $isCorrect }) => {
        if ($type === 'predicted') return 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
        if ($isCorrect) return 'linear-gradient(135deg, #28a745 0%, #20c997 100%)';
        return 'linear-gradient(135deg, #dc3545 0%, #e83e8c 100%)';
    }};
    color: white;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    min-width: 90px;
    text-align: center;

    @media (max-width: 768px) {
        font-size: 1.125rem;
        padding: 0.5rem 0.875rem;
        min-width: 70px;
    }
`;

export const WinnerDivider = styled.div`
    width: 2px;
    height: 60px;
    background: linear-gradient(to bottom, transparent, #dee2e6, transparent);

    @media (max-width: 768px) {
        height: 50px;
    }
`;

export const ConfidenceText = styled.div`
    font-size: 0.75rem;
    color: #6c757d;
    font-weight: 500;

    @media (max-width: 768px) {
        font-size: 0.625rem;
    }
`;

export const DetailLabel = styled.div`
    font-size: 0.75rem;
    color: #6c757d;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-weight: 600;
`;

export const Divider = styled.div`
    height: 1px;
    background: #dee2e6;
    margin: 0 1.5rem;
`;

export const ExpandableSection = styled.div`
    background: white;
    margin: 0 1.5rem 1.5rem;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
`;

export const ExpandButton = styled.button`
    width: 100%;
    padding: 1rem;
    background: white;
    border: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    font-weight: 600;
    color: #495057;
    transition: background 0.2s;
    font-size: 0.875rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;

    &:hover {
        background: #f8f9fa;
    }
`;

export const ExpandIcon = styled.span`
    transition: transform 0.3s;
    transform: ${({ $expanded }) => ($expanded ? 'rotate(180deg)' : 'rotate(0)')};
    color: #667eea;
`;

export const DetailGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;
    padding: 1rem;

    @media (min-width: 768px) {
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    }
`;

export const DetailCard = styled.div`
    padding: 1rem;
    background: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #e9ecef;
`;

export const DetailValue = styled.div`
    font-size: 1rem;
    font-weight: 600;
    color: #495057;
    margin-top: 0.25rem;
`;

export const CloseButton = styled.button`
    position: absolute;
    top: 1rem;
    right: 1rem;
    background: white;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
    color: #495057;
    z-index: 1000;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.2s;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    &:hover {
        background-color: #f8f9fa;
        transform: scale(1.1);
    }

    @media (max-width: 768px) {
        top: 0.75rem;
        right: 0.75rem;
    }
`;
